import * as z from 'zod';

const TagZod = z.object({
  id: z.number(),
  text: z.string(),
});

export { TagZod };
export type TagType = z.infer<typeof TagZod>;
